module.exports = __webpack_public_path__ + "static/pets-section-bg-01d6050df46325936f8f89a23b89dea3.png";